__turbopack_context__.v({
  "active": "ServiceShowcaseIcon-module-scss-module__mlyTvW__active",
  "blip": "ServiceShowcaseIcon-module-scss-module__mlyTvW__blip",
  "core": "ServiceShowcaseIcon-module-scss-module__mlyTvW__core",
  "draw": "ServiceShowcaseIcon-module-scss-module__mlyTvW__draw",
  "draw-path": "ServiceShowcaseIcon-module-scss-module__mlyTvW__draw-path",
  "flow-draw": "ServiceShowcaseIcon-module-scss-module__mlyTvW__flow-draw",
  "flow-pop": "ServiceShowcaseIcon-module-scss-module__mlyTvW__flow-pop",
  "icon": "ServiceShowcaseIcon-module-scss-module__mlyTvW__icon",
  "link": "ServiceShowcaseIcon-module-scss-module__mlyTvW__link",
  "mesh": "ServiceShowcaseIcon-module-scss-module__mlyTvW__mesh",
  "mesh-draw": "ServiceShowcaseIcon-module-scss-module__mlyTvW__mesh-draw",
  "mesh-pop": "ServiceShowcaseIcon-module-scss-module__mlyTvW__mesh-pop",
  "orbit": "ServiceShowcaseIcon-module-scss-module__mlyTvW__orbit",
  "orbitBlip": "ServiceShowcaseIcon-module-scss-module__mlyTvW__orbitBlip",
  "orbitInner": "ServiceShowcaseIcon-module-scss-module__mlyTvW__orbitInner",
  "pop": "ServiceShowcaseIcon-module-scss-module__mlyTvW__pop",
  "product": "ServiceShowcaseIcon-module-scss-module__mlyTvW__product",
  "radar-blip": "ServiceShowcaseIcon-module-scss-module__mlyTvW__radar-blip",
  "radarBlip": "ServiceShowcaseIcon-module-scss-module__mlyTvW__radarBlip",
  "ring": "ServiceShowcaseIcon-module-scss-module__mlyTvW__ring",
  "source-pulse": "ServiceShowcaseIcon-module-scss-module__mlyTvW__source-pulse",
  "sourcePulse": "ServiceShowcaseIcon-module-scss-module__mlyTvW__sourcePulse",
  "spin": "ServiceShowcaseIcon-module-scss-module__mlyTvW__spin",
  "star": "ServiceShowcaseIcon-module-scss-module__mlyTvW__star",
  "sweep": "ServiceShowcaseIcon-module-scss-module__mlyTvW__sweep",
  "sweep-fadein": "ServiceShowcaseIcon-module-scss-module__mlyTvW__sweep-fadein",
  "twinkle": "ServiceShowcaseIcon-module-scss-module__mlyTvW__twinkle",
});
